export default {
  accountSets: {
    list: (params = {}) => Ajax.get('/account-sets', params),
    save: (data) => Ajax.post('/account-sets', data),
    update: (data) => Ajax.put('/account-sets', data),
    delete: (id, msgCode) => Ajax.delete(`/account-sets/${id}?msgCode=${msgCode}`),
    checkUse: (id) => Ajax.get(`/account-sets/checkUse/${id}`),
    updateEncode: (data) => Ajax.post('/account-sets/updateEncode', data),
    addUser: (accountSetsId, mobile, role) => Ajax.get(`/account-sets/addUser?accountSetsId=${accountSetsId}&mobile=${mobile}&role=${role}`),
    updateUserRole: (id, role) => Ajax.get(`/account-sets/updateUserRole?id=${id}&role=${role}`),
    addNewUser: (params) => Ajax.get('/account-sets/addNewUser', params),
    removeUser: (uid) => Ajax.get(`/account-sets/removeUser/${uid}`),
    identification: (data) => Ajax.post('/account-sets/identification', data),
    handOver: (data) => Ajax.post('/account-sets/handOver', data),
    changeEnable: (data) => Ajax.post('/account-sets/changeEnable', data),
    renew: (data) => Ajax.post('/account-sets/renew', data),
    reset: (data) => Ajax.post('/account-sets/reset', data),
  },
  sync: {
    page: (p) => Ajax.post('/setting/sync/page', p),
    save: (d) => Ajax.post('/setting/sync/save', d),
    startSync: (id) => Ajax.post('/setting/sync/startSync/' + id),
    delete: (id) => Ajax.post('/setting/sync/delete/' + id),
  },
  backup: {
    page: (p) => Ajax.post('/setting/backup/page', p),
    start: (p) => Ajax.post('/setting/backup/start', p),
    upload: (d) => Ajax.post('/setting/backup/upload', d),
    setEmailAuto: (p) => Ajax.post('/setting/backup/setEmailAuto', p),
    restore: (id) => Ajax.post('/setting/backup/restore/' + id),
    download: (id) => Ajax.post('/setting/backup/download/' + id),
  },
  auditExport: {
    years: () => Ajax.get('/setting/audit-export/years'),
    page: (p) => Ajax.post('/setting/audit-export/page', p),
    export: (p) => Ajax.post('/setting/audit-export/export', p),
  },
  auditLog: {
    page: (p) => Ajax.post('/setting/audit-log/page', p),
    modules: () => Ajax.get('/setting/audit-log/modules'),
    clear: () => Ajax.post('/setting/audit-log/clear'),
  },
  subject: {
    list: (params = {}) => Ajax.get('/subject', params),
    load: (id) => Ajax.get(`/subject/${id}`),
    save: (data) => Ajax.post('/subject', data),
    update: (data) => Ajax.put('/subject', data),
    delete: (id) => Ajax.delete(`/subject/${id}`),
    loadByCode: (code, params = {}) => Ajax.get('/subject/loadByCode', Object.assign({ code }, params)),
    import: (formData) => Ajax.post('/subject/import', formData),
    cashFlowMap: () => Ajax.get('/subject/cashFlowMap'),
    saveCashFlowMap: (rows) => Ajax.post('/subject/cashFlowMap', rows),
    transferAuxiliary: (data) => Ajax.post('/subject/transferAuxiliary', data),
    voucherSelect: (params = {}) => Ajax.get('/subject/voucher/select', params),
    balance: (params = {}) => Ajax.get('/subject/balance', params),
  },
  currency: {
    list: (params = {}) => Ajax.get('/currency', params),
    save: (data) => Ajax.post('/currency', data),
    update: (data) => Ajax.put('/currency', data),
    delete: (id) => Ajax.delete(`/currency/${id}`),
  },
  voucherWord: {
    list: (params = {}) => Ajax.get('/voucher-word', params),
    save: (data) => Ajax.post('/voucher-word', data),
    update: (data) => Ajax.put('/voucher-word', data),
    delete: (id) => Ajax.delete(`/voucher-word/${id}`),
  },
  initialBalance: {
    list: (params = {}) => Ajax.get('/initial-balance', params),
    save: (data) => Ajax.post('/initial-balance', data),
    saveAuxiliary: (data) => Ajax.post('/initial-balance/auxiliary', data),
    trialBalance: (params = {}) => Ajax.get('/initial-balance/trialBalance', params),
    importData: (formData) => Ajax.post('/initial-balance/import', formData),
    clear: () => Ajax.post('/initial-balance/clear'),
    cashFlow: () => Ajax.get('/initial-balance/cashFlow'),
    saveCashFlow: (data) => Ajax.post('/initial-balance/cashFlow', data),
  },
  accountingCategory: {
    list: (params = {}) => Ajax.get('/accounting-category', params),
    load: (id) => Ajax.get(`/accounting-category/${id}`),
    save: (data) => Ajax.post('/accounting-category', data),
    update: (data) => Ajax.put('/accounting-category', data),
    delete: (id) => Ajax.delete(`/accounting-category/${id}`),
    import: (formData) => Ajax.post('/accounting-category/import', formData),
  },
  accountingCategoryDetails: {
    list: (id, params = {}) => Ajax.get('/accounting-category-details', Object.assign({ id }, params)),
    load: (id) => Ajax.get(`/accounting-category-details/${id}`),
    save: (data) => Ajax.post('/accounting-category-details', data),
    update: (data) => Ajax.put('/accounting-category-details', data),
    delete: (id) => Ajax.delete(`/accounting-category-details/${id}`),
    clearData: (id) => Ajax.delete(`/accounting-category-details/clear/${id}`),
    loadAuxiliaryAccountingData: (data) => Ajax.post('/accounting-category-details/loadAuxiliaryAccountingData', data),
  },
  voucherTemplate: {
    list: (params = {}) => Ajax.get('/voucher-template', params),
    load: (id) => Ajax.get(`/voucher-template/${id}`),
    delete: (id) => Ajax.delete(`/voucher-template/${id}`),
  },
  user: {
    list: (params = {}) => Ajax.get('/user', params),
  },
};
